import colors from 'style-utils/colors';
import { withMargin, WithMarginProps } from 'style-utils/dimensionsMixins';
import styled from 'styled-components';

export type IconRootProps = {
  iconSize?: string;
  iconHeight?: string;
  iconMinWidth?: string;
  className?: string;
  iconSrc?: string;
  inlineIconSrc?: boolean;
  display?: string;
} & WithMarginProps;

export const IconRoot = styled.div.attrs<IconRootProps>(
  ({ iconSrc, inlineIconSrc }) => ({
    // Use style directly as a performance optimization when you need to render
    // a alot of icons:
    // inlined styles can be overridden only with '!important'.
    style: {
      backgroundImage:
        iconSrc && inlineIconSrc ? `url("${iconSrc}")` : undefined,
    },
  }),
)<IconRootProps>`
  display: ${({ display }) => display ?? 'inline-block'};
  align-items: center;
  justify-content: center;
  padding: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  ${({ iconSize = '24px', iconHeight, iconMinWidth }) => `
    width: ${iconMinWidth || iconSize};
    height: ${iconHeight || iconMinWidth || iconSize};
    min-width: ${iconMinWidth};
  `};
  ${({ iconSrc, inlineIconSrc }): string => {
    if (iconSrc && !inlineIconSrc) {
      return `background-image: url("${iconSrc}");`;
    }
    return '';
  }};

  ${withMargin};
  &.communityCard {
    background-size: cover;
    border-radius: 135px;
    border: 1.88px solid ${colors.white};
    margin-right: 12px;
  }
`;
IconRoot.defaultProps = {
  margin: '0',
  inlineIconSrc: false,
  'aria-hidden': true,
};
